import { render, staticRenderFns } from "./CollageGoods.vue?vue&type=template&id=1a6dcb53&scoped=true"
import script from "./CollageGoods.vue?vue&type=script&lang=js"
export * from "./CollageGoods.vue?vue&type=script&lang=js"
import style0 from "./CollageGoods.vue?vue&type=style&index=0&id=1a6dcb53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6dcb53",
  null
  
)

export default component.exports